import config from '../../config';

async function postTableData(path, payload) {
    let response;
    try {
        response = await fetch(config.apiUrl + path, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });
    } catch (cause) {
        const error = new Error(cause && cause.message
            ? cause.message
            : 'Unable to connect to the server');
        error.status = 0;
        error.retryable = true;
        throw error;
    }
    let data = null;
    try {
        data = await response.json();
    } catch (parseError) {
        data = null;
    }

    if (!response.ok) {
        const error = new Error((data && data.error) || 'Unable to save OEE data');
        error.status = response.status;
        error.retryable = data ? data.retryable !== false : response.status >= 500;
        throw error;
    }

    return data;
}

export const tableDataWriteService = {
    create: (payload) => postTableData('/upload2', payload),
    update: (payload) => postTableData('/update', payload),
    remove: (payload) => postTableData('/delete', payload),
};
